import { render, staticRenderFns } from "./auto-message-set-send-mode-dialog.vue?vue&type=template&id=0f822ef8&scoped=true&"
import script from "./auto-message-set-send-mode-dialog.vue?vue&type=script&lang=js&"
export * from "./auto-message-set-send-mode-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f822ef8",
  null
  
)

export default component.exports